import { checkTaskStatusRpc, generateLayoutAsyncRpc } from '../../__generated__/chirp/com/hubspot/content/ai/editor/rpc/LayoutGeneration';
import rpcClient from './RpcClient';
export const startLayoutGenerationTask = ({
  task,
  contentId,
  focusedNodeId,
  gridLayout
}) => {
  return rpcClient.call(generateLayoutAsyncRpc, {
    request: {
      task,
      contentId,
      focusedNodeId,
      gridLayout
    }
  });
};
export const fetchLayoutGenerationTask = taskId => {
  return rpcClient.call(checkTaskStatusRpc, {
    request: {
      taskId
    }
  });
};